export interface AspenApiConfigInterface {
    aspenApiUrl: string
}

export const aspenApiConfig: AspenApiConfigInterface = {
    aspenApiUrl: process.env.REACT_APP_ASPEN_API_URL as string
}
